import 'moment/locale/es';
import { Loader } from 'mol-ui';
import PropTypes from 'prop-types';
import { accountActions } from 'core/Account';
import { config } from 'config';
import { configActions } from 'core/Config';
import { dashboardActions } from 'core/Dashboard';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import {
    ErrorMessage,
    RoleSelector
} from 'views/components';
import React, { useEffect } from 'react';
import {
    UpdateBar,
    UpdateLink
} from './styled';
import {
    useDispatch,
    useSelector
} from 'hooks';
const { ssoLogin } = config;

const App = ({
    children
}) => {

    moment.locale('es');

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const {
        error,
        loaded
    } = useSelector('config');

    useEffect(() => {
        if (!loaded && !error) {
            dispatch(configActions.getConfig());
        }
    }, [error, loaded]);

    useEffect(() => {
        dispatch(accountActions.checkToken());
        dispatch(accountActions.checkVersion());
        dispatch(dashboardActions.setDashboardSockets());
    }, []);

    const handleReload = () => {
        window.location.reload(true);
    };

    if (error) {
        return (
            <ErrorMessage
                relative
                error={ t('Ocurrió un error al obtener la configuración de la plataforma') }
                margin="10px"
            />
        );
    }

    return (
        <>
            {
                !loaded
                    ? <Loader active size={ 50 } type="dots" />
                    : children
            }
            { loaded && ssoLogin && <RoleSelector /> }
            <UpdateBar className="display-none" id="new-version" onClick={ handleReload } >
                <UpdateLink>
                    <>
                        { t('Hay una nueva versión disponible') } <br />
                        { t('Presione aquí para cargarla') }
                    </>
                </UpdateLink>
            </UpdateBar>
        </>
    );

};

App.propTypes = {
    children: PropTypes.any
};

export default App;
